import { ITileWithIcon, TileIcon } from './ITileWithIcon';
// tslint:disable:variable-name
import { MultiString } from '../../common/index';

export enum ApplicationUrlType {
    Inner = 'inner',
    Outer = 'outer'
}

export class Application {
    /// id
    public id: string;
    /// name
    public name: MultiString;
    /// description
    public description?: MultiString;
    public product?: string;
    /// group
    public group?: string;
    public copyrights?: any;
    /// url
    public url: {
        type: ApplicationUrlType,
        link: string,
        state?: string,
        state_params?: { [param: string]: string | number | boolean },
        params?: {
            target?: string;
            [param: string]: string | number | boolean;
        }
    };
    /// Application icon
    public icon?: string;
    public min_ver?: number;
    public max_ver?: number;
    public access_rights?: string[];
    public params?: {
        hidden?: boolean;
        [key: string]: string | number | boolean;
    };
}

export class ApplicationTile extends Application implements ITileWithIcon {
    public isHidden?: boolean;
    public isFavorite?: boolean;
    public iconView: TileIcon;
    click?: () => void;
}
